/* eslint no-bitwise: 0 */

/**
 * @public
 * Gets all repeated values between two arrays.
 *
 * @see https://gist.github.com/jherax/51643b2f7622429b9418d9388b4af99f
 *
 * @param  {Array} array1: array to compare
 * @param  {Array} array2: array to compare
 * @return {Array}
 */
export default function repeatedValues(array1, array2) {
  return array1.reduce((repeated, value) => {
    if (~array2.indexOf(value) && !~repeated.indexOf(value)) {
      repeated.push(value);
    }
    return repeated;
  }, []);
}
